{
  "el": {
    "installment_term": {
      "actions": {
        "addUnits": "Ακίνητα",
        "add_fraction": "Προσθήκη κανόνα",
        "create": "Δημιουργία",
        "create_and_share": "Δημιουργία και κοινοποίηση στον πελάτη",
        "create_price_term": "Νέος κανόνας",
        "delete": "Διαγραφή",
        "deleteMultiple": "Διαγραφή...",
        "delete_cancel": "Ακύρωση",
        "edit": "Επεξεργασία",
        "newInstallment": "Πρόγραμμα δόσεων",
        "only_create": "Μόνο δημιουργία",
        "publish_customer": "Δημοσίευση για τον πελάτη",
        "selectAll": "Επιλογή όλων των {total} δόσεων",
        "selectOne": "Επιλογή μίας δόσης",
        "take": "Είσπραξη"
      },
      "attributes": {
        "description": "Περιγραφή",
        "installments_count": "{count} δόση | {count} δόσεις",
        "name": "Τίτλος"
      },
      "labels": {
        "addAllSurcharges": "Όλες οι τρέχουσες αναβαθμίσεις",
        "addAllUnitsPrices": "Όλες οι τιμές ακινήτων",
        "amount": "Ποσό δόσης",
        "balanceFractionTypes": "Τύποι κανόνων υπολοίπου",
        "balanceTotal": "Συνολικό υπόλοιπο",
        "containsSurcharges": "Περιέχει αναβαθμίσεις",
        "create_decision_first": "Αυτή η επιλογή θα γίνει διαθέσιμη μόλις δημιουργήσεις μια απόφαση.",
        "deleteInstallmentTerm": "Διαγραφή προγράμματος δόσεων",
        "description": "Περιγραφή",
        "documents": "Έγγραφα",
        "duplicate_price_type": "Υπάρχει ήδη κανόνας με αυτόν τον τύπο τιμής.",
        "editInstallmentTerm": "Επεξεργασία προγράμματος δόσεων",
        "edit_description": "Επεξεργασία περιγραφής",
        "fixed": "Σταθερό",
        "fixedAmount": "Σταθερό ποσό",
        "for": "για",
        "forEachUnit": "κάθε ακινήτου",
        "fraction_types": {
          "absolute": "Σταθερό ποσό",
          "relative": "Ποσοστό"
        },
        "goToAmounts": "Επιλογή ποσών",
        "installments": "Οικονομικά",
        "installmentsTitle": "Δόση",
        "installments_all_projects": "Οικονομικά όλων των έργων",
        "invalidAmount": "Μη έγκυρο ποσό",
        "list": "Λίστα",
        "name": "Πρόγραμμα δόσεων #{count}",
        "noContainsSurcharges": "Δεν περιέχει αναβαθμίσεις",
        "noInstallmentsToPay": "Δεν εκκρεμούν δόσεις",
        "noUnitsClick": "Δεν υπάρχουν ακόμη ακίνητα, κάνε κλικ εδώ για προσθήκη",
        "ofThe": "από",
        "price_types": {
          "custom_amount": "Άλλο",
          "price_value": "Συνολική αξία",
          "price_value_construction": "Αξία κατασκευής",
          "price_value_construction_existing": "Κόστος υφιστάμενης κατασκευής",
          "price_value_fees": "Αμοιβές αρχιτέκτονα/μηχανικού",
          "price_value_land": "Αξία οικοπέδου",
          "surcharge": "Αναβαθμίσεις",
          "unit": "Τιμές ακινήτων"
        },
        "projectUnitsTotal": "{project_name} έχει συνολικά {units_count_max} ακίνητα",
        "publish_now": "Δημοσίευση τώρα;",
        "rules": "Κανόνες πληρωμής",
        "rules_subtitle": "Όρισε τι ποσοστό ή ποσό θα εισπραχθεί",
        "save_explainer": "Να γίνει αυτό το πρόγραμμα δόσεων ορατό στους πελάτες σου; Ή να το αποθηκεύσεις και να το δημοσιεύσεις αργότερα;",
        "selectUnits": "Επιλογή ακινήτων",
        "selected": "Επιλέχθηκε {selected} δόση. | Επιλέχθηκαν {selected} δόσεις.",
        "shortcuts": "Συντομεύσεις",
        "show_installment_terms_for": "Εμφάνιση δόσεων για",
        "step1Info": "Πρόσθεσε μια περιγραφή",
        "step2Subtitle": "Επίλεξε το έργο σου για να συμπεριλάβεις όλα τα ακίνητα με μία κίνηση.",
        "step2Title": "Ποια ακίνητα σχετίζονται με αυτή τη δόση;",
        "surcharges": "Αναβαθμίσεις",
        "total": "Σύνολο",
        "totalFixed": "Σύνολο σταθερών",
        "totalPaid": "Σύνολο πληρωμένων",
        "totalRequested": "Σύνολο τιμολογημένων",
        "totalSelected": "Έχουν επιλεγεί και οι {total} δόσεις.",
        "totalSurcharges": "Σύνολο αναβαθμίσεων",
        "totalUnpaid": "Σύνολο απλήρωτων",
        "unitSelected": "Δεν έχει επιλεγεί ακόμη ακίνητο | Επιλέχθηκε ένα ακίνητο | Επιλέχθηκαν {count} ακίνητα",
        "units": "Ακίνητα"
      },
      "navigation": {
        "backToInstallmentTerms": "Επιστροφή στην επισκόπηση προγραμμάτων δόσεων"
      },
      "placeholders": {
        "amount": "Επίλεξε σταθερό ποσό ή ποσοστό της αξίας του ακινήτου ή των αναβαθμίσεων",
        "description": "Π.χ. 10% - Μετά τη σκυροδέτηση της πλάκας του πρώτου ορόφου...",
        "due_date": "Όρισε την ημερομηνία μέχρι την οποία πρέπει να πληρωθεί η δόση",
        "employees": {
          "new": {
            "subtitle": "Πρόσθεσε δόσεις και παρακολούθησε την κατάστασή τους",
            "title": "Δημιούργησε μια οικονομική επισκόπηση"
          }
        },
        "installmentTermFractionNotice": "Τα ποσά των δόσεων δεν μπορούν πλέον να τροποποιηθούν, επειδή ορισμένες δόσεις έχουν ήδη σταλεί στον αγοραστή",
        "name": "Π.χ. Πρόγραμμα δόσεων #1, Πρόγραμμα δόσεων - Αναβαθμίσεις",
        "summary": "Σύνοψη",
        "surcharge": "αναβάθμιση"
      },
      "toasts": {
        "bulk_create": "Η δόση δημιουργήθηκε | Οι δόσεις δημιουργήθηκαν",
        "bulk_delete": "Η δόση διαγράφηκε | Οι δόσεις διαγράφηκαν",
        "bulk_update": "Η δόση ενημερώθηκε | Οι δόσεις ενημερώθηκαν",
        "delete": "Η δόση διαγράφηκε",
        "update": "Η δόση ενημερώθηκε"
      },
      "validation": {
        "fixedFractionLabel": "Ο τύπος {price_type} έχει ήδη συνδυαστεί με {fraction_type} σε άλλη υπάρχουσα δόση. Επιτρέπεται μόνο {fraction_type} για λόγους συνέπειας.",
        "maxLengthName": "Το όνομα είναι πολύ μεγάλο",
        "needDescription": "Απαιτείται περιγραφή",
        "needInstallmentTermFraction": "Απαιτείται τουλάχιστον μία τιμή κανόνα",
        "needName": "Απαιτείται όνομα",
        "needUniquePricesTypes": "Οι κανόνες δεν μπορούν να έχουν τους ίδιους τύπους τιμής μέσα στο ίδιο πρόγραμμα δόσεων",
        "needValidTerm": "Το ποσό δεν μπορεί να είναι 0 και ο τύπος τιμής πρέπει να υπάρχει",
        "selectInstallmentTerm": "Επίλεξε τουλάχιστον 1 δόση",
        "selectUnit": "Επίλεξε τουλάχιστον 1 ακίνητο"
      }
    }
  }
}
